type InvoiceDueDate = {
    id: string | number;
    dueDate?: string | null;
};

type InvoiceWithId = {
    id: string | number;
};

export const getOverdueInvoices = <T extends InvoiceWithId>(
    unpaidInvoices: T[],
    invoices: InvoiceDueDate[],
    referenceDate: Date,
    gracePeriodDays: number
): T[] => {
    const dueDatesById = new Map(invoices.map(invoice => [invoice.id, invoice.dueDate]));
    const today = new Date(referenceDate);
    today.setHours(0, 0, 0, 0);

    return unpaidInvoices.filter(unpaidInvoice => {
        const dueDateString = dueDatesById.get(unpaidInvoice.id);
        if (!dueDateString) return false;

        const dueDate = new Date(dueDateString);
        if (Number.isNaN(dueDate.getTime())) return false;
        dueDate.setHours(0, 0, 0, 0);

        const gracePeriodDeadline = new Date(dueDate);
        gracePeriodDeadline.setDate(gracePeriodDeadline.getDate() + gracePeriodDays);

        return today > gracePeriodDeadline;
    });
};

export const getInvoiceDueDateLabel = (
    dateString: string | null | undefined,
    referenceDate: Date = new Date()
): string => {
    if (!dateString) return '';

    const dueDate = new Date(dateString);
    dueDate.setHours(0, 0, 0, 0);

    const today = new Date(referenceDate);
    today.setHours(0, 0, 0, 0);

    const dueDateLabel = dueDate < today ? 'Förfallen' : 'Förfaller';
    return `${dueDateLabel} ${new Date(dateString).toLocaleDateString('sv-SE')}`;
};